
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightRainShowersPolartwilight as ObiLightRainShowersPolartwilightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-rain-showers-polartwilight.js';
 
 
 

 
 export const ObiLightRainShowersPolartwilight = createComponent({
   react: React,
   tagName: 'obi-light-rain-showers-polartwilight',
   elementClass: ObiLightRainShowersPolartwilightElement,
   events: {
     
   }
  });
 
 